import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
import { InputBase } from '@mui/material';

// See https://imask.js.org/guide.html#masked-number for more options
const DecimalInputMask = forwardRef((props, ref) => {
	const { onChange, allowNegative, precision, ...other } = props;
	return (
		<IMaskInput
			{...other}
			mask={Number}
			unmask={true}
			inputRef={ref}
			onAccept={(value) => onChange({ target: { name: props.name, value } })}
			scale={precision}
			padFractionalZeros={false}
			radix={'.'}
			signed={allowNegative}
			thousandsSeparator={','}
		/>
	);
})

const DecimalInput = (props) => {
	const { value, onChange, allowNegative, precision, min, max, ...other } = props;
	let v = numberWithCommas(value);

	return (
		<InputBase
		{...other}
		value={v}
		inputComponent={DecimalInputMask}
		inputProps={{value:v, onChange, allowNegative, precision, min, max}} />
	)
}

function numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

DecimalInput.defaultProps = {
	value: 0,
	onChange: () => {},
	allowNegative: false,
	precision: 2
}

DecimalInput.propTypes = {
	value: PropTypes.number,
	onChange: PropTypes.func,
	allowNegative: PropTypes.bool,
	precision: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
}


export default DecimalInput;